export default __webpack_public_path__ + "assets/images/ff98a7dc1fc4ae56d33bf33371ee23f1.png";